import React, { Component } from 'react'

class DropShadowFilter extends Component {
  static filterID = 'dropshadow'
  render() {
    return (
      <filter id="dropshadow" height="200%" width="200%" x="-50%" y="-50%">
        <feGaussianBlur in="SourceAlpha" stdDeviation="3" result="blur" />
        <feOffset in="blur" dx="0" dy="0" result="offsetBlur" />
        <feFlood floodColor="#8b8b8b" floodOpacity="0.4" result="offsetColor" />
        <feComposite in="offsetColor" in2="offsetBlur" operator="in" result="offsetBlur" />
        <feMerge>
          <feMergeNode />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
    )
  }
}

DropShadowFilter.displayName = 'DropShadowFilter'

export default DropShadowFilter
